import React, { Component } from 'react';

export default class RkPayContent extends Component {
	shouldComponentUpdate = () => false;

	render() {
		return (
			<div className="panel margin-bottom-10 border-radius-0 padding-30">
				<span className="font-size-30 color-gray-mako">Benefits of RKPay</span>
				<p>Great benefits await by using RKPay, including :</p>
				<ol className="margin-top-20">
					<li className="margin-bottom-10">RKPay simplifies your life.</li>
					<li className="margin-bottom-10">Track your payment and easily import your data.</li>
					<li className="margin-bottom-10">Our team will review the content and reply back within 24-48 hours with a response.</li>
					<li className="margin-bottom-10">You can approve payment with so much ease. Your officers are happy using RKPay.</li>
				</ol>
				<div className="margin-top-30 margin-bottom-30 flex">
					<img
						className="margin-right-20 height-30"
						src="/images/rkPayProf.png"
						alt="RKPay Badge"
					/>
					<span className="color-gray-mine-shaft font-bold">Thousands of officers prefer getting paid using RKPay. Faster. Easier.</span>
				</div>
			</div>
		);
	}
}
